import moment from "moment-timezone";
import ModalQuestion from "../../../components/blocks/ModalQuestion";
import ModalSimple from "../../../components/blocks/ModalSimple";
import ModalNote from "../../../components/blocks/SchedulePage/ModalNote";
import ModalPersonalTask from "../../../components/blocks/SchedulePage/ModalPersonalTask";
import ModalReschedule from "../../../components/blocks/SchedulePage/ModalReschedule";
import { LoadingContainer } from "../../../components/containers/LoadingContainer";
import { Button } from "../../../components/controls/Button/Button";
import { color_red_default, color_white } from "../../../constants/colors";
import { MODAL_Z_INDEX_NESTED } from "../../../constants/layers";
import PersonalDefaultPage from "../PersonalDefaultPage";
import ScheduleCalendar from "./ScheduleCalendar";
import ScheduleHeader from "./ScheduleHeader";
import { useScheduleData } from "./useScheduleData";
import { useScheduleLessonModals } from "./useScheduleLessonModals";
import { useSchedulePersonalEvents } from "./useSchedulePersonalEvents";
import { useI18n } from "../../../i18n/I18nProvider";

export const SchedulePage = () => {
  const { t } = useI18n();
  const {
  schedule,
    student,
    user,
    dispatch,
    timeZone,
    scheduleWeekRange,
    setScheduleWeekRange,
    isLoading,
    loadData,
  } = useScheduleData();

  const lessonModals = useScheduleLessonModals({
    timeZone,
    schedule,
    student,
    user,
    dispatch,
    loadData,
  });

  const personalEvents = useSchedulePersonalEvents({
    timeZone,
    loadData,
    setModalSuccessText: lessonModals.setModalSuccessText,
    setModalAlertText: lessonModals.setModalAlertText,
    setModalErrorText: lessonModals.setModalErrorText,
  });

  return (
    <PersonalDefaultPage>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignSelf: "flex-start",
          gap: 20,
        }}
      >
        <LoadingContainer isLoading={isLoading}>
          <ModalSimple
            type={"success"}
            h2={lessonModals.modalSuccessText}
            isOpen={lessonModals.modalSuccessText !== ""}
            onClose={lessonModals.setModalSuccessText}
            zIndex={MODAL_Z_INDEX_NESTED}
          />
          <ModalSimple
            type={"alert"}
            h2={lessonModals.modalAlertText}
            isOpen={lessonModals.modalAlertText !== ""}
            onClose={lessonModals.setModalAlertText}
            buttonText={t("Хорошо")}
            zIndex={MODAL_Z_INDEX_NESTED}
          />
          <ModalSimple
            type={"error"}
            h2={lessonModals.modalErrorText}
            isOpen={lessonModals.modalErrorText !== ""}
            onClose={lessonModals.setModalErrorText}
            zIndex={MODAL_Z_INDEX_NESTED}
          />
          <ModalQuestion
            type={"question"}
            h2={t("Удалить личное событие?")}
            p={t("Вы уверены, что хотите удалить это событие?")}
            isOpen={personalEvents.isConfirmDeleteTaskOpen}
            onClose={personalEvents.handleConfirmDeletePersonalTask}
            yesText={t(personalEvents.isDeletingPersonalTask ? "Удаляем..." : "Удалить")}
            noText={t(personalEvents.isDeletingPersonalTask ? "Подождите..." : "Отмена")}
            isLoading={personalEvents.isDeletingPersonalTask}
            zIndex={MODAL_Z_INDEX_NESTED}
          />
          <ModalPersonalTask
            isOpen={personalEvents.isPersonalTaskModalOpen}
            onClose={personalEvents.closePersonalTaskModal}
            onSave={personalEvents.savePersonalTask}
            initialTask={personalEvents.personalTaskForModal}
            existingEvents={schedule}
          />
          {lessonModals.isShowModalNote && (
            <ModalNote
              lessonData={lessonModals.lessonForModal}
              isOpen={lessonModals.isShowModalNote}
              onClose={lessonModals.memoCloseModalNote}
              onSave={lessonModals.memoSaveNote}
            />
          )}
          {lessonModals.isShowModalReschedule && (
            <ModalReschedule
              lessonData={lessonModals.lessonForModal}
              isOpen={lessonModals.isShowModalReschedule}
              onClose={lessonModals.memoCloseModalReschedule}
              onSave={lessonModals.memoSaveDateTime}
            />
          )}
          <ScheduleHeader
            scheduleWeekRange={scheduleWeekRange}
            setScheduleWeekRange={setScheduleWeekRange}
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div title={t("Добавить событие")}>
              <Button
                type="button"
                width={36}
                height={36}
                backgroundColor={color_red_default}
                borderColor={color_red_default}
                color={color_white}
                fontSize={24}
                onClick={personalEvents.openCreatePersonalTaskModal}
                style={{
                  borderRadius: 8,
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                +
              </Button>
            </div>
          </div>
          <ScheduleCalendar
            onOpenModalNote={lessonModals.memoOpenModalNote}
            onOpenModalReschedule={lessonModals.memoOpenModalReschedule}
            onOpenPersonalEventEdit={personalEvents.openEditPersonalTaskModal}
            onDeletePersonalEvent={personalEvents.deletePersonalTask}
            schedule={schedule.filter(
              (el) =>
                moment(el.dateDate).isSameOrAfter(scheduleWeekRange[0]) &&
                moment(el.dateDate).isSameOrBefore(scheduleWeekRange[1]),
            )}
            weekDayRange={scheduleWeekRange}
          />
        </LoadingContainer>
      </div>
    </PersonalDefaultPage>
  );
};
